import { normalizeCategory } from './categoryUtils';

const KEY        = 'nexsap_taste_v1';
const SEARCH_KEY = 'nexsap_searches_v1';

function load() {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; }
  catch { return {}; }
}
function save(data) {
  try { localStorage.setItem(KEY, JSON.stringify(data)); } catch {}
}

// Visite d'une catégorie → poids 1
export function trackCategory(catValue) {
  if (!catValue) return;
  const norm = normalizeCategory(catValue);
  if (!norm) return;
  const data = load();
  data[norm] = (data[norm] || 0) + 1;
  save(data);
}

// Like d'un produit → poids 5 (signal fort)
export function trackLike(catValue) {
  if (!catValue) return;
  const norm = normalizeCategory(catValue);
  if (!norm) return;
  const data = load();
  data[norm] = (data[norm] || 0) + 5;
  save(data);
}

// Sauvegarde un terme de recherche (max 10 termes uniques)
export function trackSearch(term) {
  const t = (term || '').trim().toLowerCase();
  if (t.length < 2) return;
  try {
    const existing = JSON.parse(localStorage.getItem(SEARCH_KEY)) || [];
    const filtered = existing.filter(s => s !== t);
    localStorage.setItem(SEARCH_KEY, JSON.stringify([t, ...filtered].slice(0, 10)));
  } catch {}
}

// Retourne l'historique des recherches
export function getSearchHistory() {
  try { return JSON.parse(localStorage.getItem(SEARCH_KEY)) || []; }
  catch { return []; }
}

// Catégories triées par préférence (la plus forte en premier)
export function getTopCategories() {
  const data = load();
  return Object.entries(data)
    .sort((a, b) => b[1] - a[1])
    .map(([cat]) => cat);
}

// Score de pertinence d'un produit (0–100)
export function scoreProduct(product, topCats) {
  const cat      = normalizeCategory(product.category || '');
  const catRank  = topCats.indexOf(cat);
  const catScore = catRank === -1 ? 0 : Math.max(0, 60 - catRank * 15);
  const likeScore = Math.min(40, (product.likes || 0) * 2);
  return catScore + likeScore;
}
